import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../api/api";
import Breadcrumbs from "../components/Breadcrumbs";
import Pagination from "../components/Pagination";
import Table from "../components/table";
import Badge from "../components/Badge";
import usePagination from "../utils/usePagination";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "./form.css";
 
const WhRequestResponses = () => {
  const { id } = useParams(); // Assuming route is /warehouse/:id/responses
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
 
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(responses, 5);
 
  // Fetch warehouse responses
  useEffect(() => {
    const fetchResponses = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/warehouse/responses?warehouse_request_id=${id}`);
        setResponses(response?.data?.data || []);
      } catch (err) {
        console.error("Failed to fetch warehouse responses:", err);
        setResponses([]);
      } finally {
        setLoading(false);
      }
    };
 
    if (id) fetchResponses();
  }, [id]);
 
  const columns = [
    { label: "Request Id", accessor: "warehouse_request_id" },
    { label: "Warehouse Name", accessor: "warehouse_name" },
    { label: "Availability", accessor: "availability_status" },
    {
      label: "Action",
      render: (item) =>
        item.availability_status === "Available" ? (
          <Link to={`/confirm-warehouse/${item.warehouse_request_id}/${item.warehouse_id}/${item.owner_id}`}>
            <ArrowForwardIcon />
          </Link>
        ) : (
          <ArrowForwardIcon style={{ color: "gray", cursor: "not-allowed" }} />
        ),
    },
  ];
 
  return (
    <>
      <Breadcrumbs />
 
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No Warehouse Responses found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
    </>
  );
};
 
export default WhRequestResponses;
 